// Import SVG icons from the categories folder - Downloaded from Figma design
import salaryIcon from '../../../Assets/JFS/assets/cateogries/salary.svg';

// Import sector icons for Mutual Funds Sector Allocation
import {
  SectorIcons,
  getSectorIconPath,
  getSectorInitials,
  getSectorInitialsColor,
  getSectorBackgroundColor,
  getSectorTextColor,
} from './SectorIconsMapping';
import taxRefundIcon from '../../../Assets/JFS/assets/cateogries/tax_refund.svg';
import taxPaymentIcon from '../../../Assets/JFS/assets/cateogries/tax_payment.svg';
import transferOutIcon from '../../../Assets/JFS/assets/cateogries/transfer_out.svg';
import transferInIcon from '../../../Assets/JFS/assets/cateogries/transfer_in.svg';
import creditCardIcon from '../../../Assets/JFS/assets/cateogries/credit_card_payments.svg';
import refundsCashbackIcon from '../../../Assets/JFS/assets/cateogries/refunds_and_cashback.svg';
import finesIcon from '../../../Assets/JFS/assets/cateogries/fines.svg';
import subscriptionsIcon from '../../../Assets/JFS/assets/cateogries/subscriptions.svg';
import otherIncomeIcon from '../../../Assets/JFS/assets/cateogries/other_income.svg';
import chequePaymentsIcon from '../../../Assets/JFS/assets/cateogries/cheque_payments.svg';
import chequeDepositsIcon from '../../../Assets/JFS/assets/cateogries/cheque_deposits.svg';
import merchantIncomeIcon from '../../../Assets/JFS/assets/cateogries/merchant_income.svg';
import subsidiesIcon from '../../../Assets/JFS/assets/cateogries/subsidies.svg';
import bnplIcon from '../../../Assets/JFS/assets/cateogries/bpnl_payment.svg';
import professionalServicesIcon from '../../../Assets/JFS/assets/cateogries/professional_services.svg';
import cashDepositsIcon from '../../../Assets/JFS/assets/cateogries/cash_deposits.svg';
import cashWithdrawalsIcon from '../../../Assets/JFS/assets/cateogries/cash_withdrawals.svg';
import alcoholIcon from '../../../Assets/JFS/assets/cateogries/alcohol_purchase.svg';
import foodGroceriesIcon from '../../../Assets/JFS/assets/cateogries/food_and_groceries.svg';
import transportationIcon from '../../../Assets/JFS/assets/cateogries/transportation.svg';
import entertainmentIcon from '../../../Assets/JFS/assets/cateogries/entertainment.svg';
import gamblingBettingIcon from '../../../Assets/JFS/assets/cateogries/gambling_and_betting.svg';
import shoppingLifestyleIcon from '../../../Assets/JFS/assets/cateogries/shopping_and_lifestyle.svg';
import utilitiesRechargesIcon from '../../../Assets/JFS/assets/cateogries/utilities_and_recharges.svg';
import investmentIncomeIcon from '../../../Assets/JFS/assets/cateogries/investment_income.svg';
import investmentExpenseIcon from '../../../Assets/JFS/assets/cateogries/investment_expense.svg';
import healthWellnessIcon from '../../../Assets/JFS/assets/cateogries/health_and_wellness.svg';
import insuranceIcon from '../../../Assets/JFS/assets/cateogries/insurance_premium.svg';
import claimIcon from '../../../Assets/JFS/assets/cateogries/claim.svg';
import rentIcon from '../../../Assets/JFS/assets/cateogries/rent.svg';
import donationIcon from '../../../Assets/JFS/assets/cateogries/donation.svg';
import educationIcon from '../../../Assets/JFS/assets/cateogries/education.svg';
import selfTransfersIcon from '../../../Assets/JFS/assets/cateogries/self_transfers.svg';
import p2pTransfersIcon from '../../../Assets/JFS/assets/cateogries/p2p_transfers.svg';
import realEstateIcon from '../../../Assets/JFS/assets/cateogries/real_estate.svg';
import interestRecoveredIcon from '../../../Assets/JFS/assets/cateogries/interest_recovered.svg';
import interestCreditIcon from '../../../Assets/JFS/assets/cateogries/interest_credit.svg';
import loanEmiIcon from '../../../Assets/JFS/assets/cateogries/loan_emi.svg';
import loanDisbursedIcon from '../../../Assets/JFS/assets/cateogries/loan_disbursal.svg';
import bankChargesIcon from '../../../Assets/JFS/assets/cateogries/bank_charges.svg';
import salaryPaymentsIcon from '../../../Assets/JFS/assets/cateogries/salary_payments.svg';
import pfWithdrawalsIcon from '../../../Assets/JFS/assets/cateogries/pf_withdrawals.svg';
import internationalTransactionsIcon from '../../../Assets/JFS/assets/cateogries/international_transactions.svg';

// Category mapping from Ignosis backend categories to JFS user-facing categories
export const CATEGORY_MAPPING: { [key: string]: string } = {
  // Income Categories
  Salary: 'Salary',
  SALARY: 'Salary',
  'Tax Refund': 'Tax refund',
  TAX_REFUND: 'Tax refund',
  'Interest Collected': 'Interest recovered',
  INTEREST_COLLECTED: 'Interest recovered',
  'Interest Credit': 'Interest credit',
  INTEREST_CREDIT: 'Interest credit',
  'Cash Deposit': 'Cash deposits',
  CASH_DEPOSIT: 'Cash deposits',
  Reversal: 'Refunds',
  REVERSAL_TXN: 'Refunds',
  Refund: 'Refunds',
  REFUND: 'Refunds',
  'Credit Sweep': 'Sweep in',
  CREDIT_SWEEP: 'Sweep in',
  'Cash Back': 'Cash back',
  CASH_BACK: 'Cash back',
  Subsidy: 'Subsidies',
  SUBSIDY: 'Subsidies',
  'Provident Fund Withdrawal': 'Provident Fund withdrawals',
  PF_WITHDRAWAL: 'Provident Fund withdrawals',
  'Investment Income': 'Investment income',
  INVESTMENT_INCOME: 'Investment income',
  'Insurance Claimed': 'Insurance claim',
  INSURANCE_CLAIMED: 'Insurance claim',
  'Transfer in': 'Transfer in',
  TRANSFER_IN: 'Transfer in',
  'Transfer from Wallet to Bank': 'Transfer in',
  TRANSFER_FROM_WALLET_TO_BANK: 'Transfer in',
  'Merchant Income': 'Merchant income',
  MERCHANT_INCOME: 'Merchant income',
  'Freelancing Income': 'Other income',
  FREELANCING_INCOME: 'Other income',
  Reimbursement: 'Others',
  REIMBURSEMENT: 'Others',

  // Expense Categories
  EMIs: 'Loan EMI',
  EMI: 'Loan EMI',
  'Loan Disbursed': 'Loan disbursal',
  LOAN_DISBURSAL: 'Loan disbursal',
  'Tax Payment': 'Tax payment',
  TAX_PAYMENT: 'Tax payment',
  'Transfer to Wallet': 'Transfer out',
  TRANSFER_TO_WALLET: 'Transfer out',
  'CASH Withdrawals': 'Cash withdrawals',
  CASH_WITHDRAWAL: 'Cash withdrawals',
  'Below Min Balance': 'Bank charges',
  MINIMUM_BALANCE_CHARGE: 'Bank charges',
  'Bank Charges': 'Bank charges',
  BANK_CHARGE: 'Bank charges',
  'Salary Paid': 'Salary payments',
  SALARY_PAID: 'Salary payments',
  'Credit Card Payment': 'Credit card payments',
  CREDIT_CARD_PAYMENT: 'Credit card payments',
  Alcohol: 'Alcohol purchase',
  ALCOHOL: 'Alcohol purchase',
  'Debit Sweep': 'Sweep out',
  DEBIT_SWEEP: 'Sweep out',
  Food: 'Food & Groceries',
  FOOD: 'Food & Groceries',
  Transportation: 'Transportation',
  TRANSPORTATION: 'Transportation',
  Travel: 'Travel & Hospitality',
  TRAVEL: 'Travel & Hospitality',
  Hotel: 'Travel & Hospitality',
  HOTEL: 'Travel & Hospitality',
  Entertainment: 'Entertainment',
  ENTERTAINMENT: 'Entertainment',
  Gaming: 'Gaming',
  GAMES: 'Gaming',
  'Gambling & Betting': 'Gambling & Betting',
  GAMBLING_AND_BETTING: 'Gambling & Betting',
  Shopping: 'Shopping',
  SHOPPING: 'Shopping',
  Utilities: 'Utilities & Recharges',
  UTILITIES: 'Utilities & Recharges',
  BNPL: 'BNPL payment',
  'Investment Expense': 'Investment expense',
  INVESTMENT_EXPENSE: 'Investment expense',
  'Health Care': 'Health & wellness',
  HEALTHCARE: 'Health & wellness',
  'Insurance Premium': 'Insurance premium',
  INSURANCE_PREMIUM: 'Insurance premium',
  Rent: 'Rent',
  RENT: 'Rent',
  'Transfer out': 'Transfer out',
  TRANSFER_OUT: 'Transfer out',
  Donation: 'Donation',
  DONATION: 'Donation',
  'Personal Care': 'Shopping & lifestyle',
  PERSONAL_CARE: 'Shopping & lifestyle',
  Education: 'Education',
  EDUCATION: 'Education',
  'Professional Service': 'Professional services',
  PROFESSIONAL_SERVICES: 'Professional services',
  'Household Expends': 'Shopping & lifestyle',
  HOUSEHOLD_EXPENDS: 'Shopping & lifestyle',
  'Business Service': 'Professional services',
  BUSINESS_SERVICES: 'Professional services',
  Leisure: 'Shopping & lifestyle',
  LEISURE: 'Shopping & lifestyle',
  Fines: 'Fines',
  FINES: 'Fines',
  'App Subscription': 'Subscriptions',
  APP_SUBSCRIPTION: 'Subscriptions',
  'Internal Transfer': 'Self transfer',
  INTERNAL_TRANSFER: 'Self transfer',
  'Forex Transaction': 'International transactions',
  FOREX_TXN: 'International transactions',
  'P2P Transfer': 'P2P transfers',
  P2P_TRANSFER: 'P2P transfers',
  'Cheque Paid': 'Cheque payments',
  CHEQUE_PAID: 'Cheque payments',
  'Cheque Deposit': 'Cheque deposits',
  CHEQUE_DEPOSIT: 'Cheque deposits',
  'Real Estate': 'Real estate',
  REAL_ESTATE: 'Real estate',

  // Bounce/Error Categories - All map to Others
  'Bounce Transaction': 'Others',
  BOUNCE_TRANSACTION: 'Others',
  'Bounced I/W Cheque': 'Others',
  BOUNCED_IW_CHEQUE: 'Others',
  'Bounced O/W Cheque': 'Others',
  BOUNCED_OW_CHEQUE: 'Others',
  'Bounced I/W ECS': 'Others',
  BOUNCED_IW_ECS: 'Others',
  'I/W Cheque Bounce Charge': 'Others',
  IW_CHEQUE_BOUNCE_CHARGE: 'Others',
  'O/W Cheque Bounce Charge': 'Others',
  OW_CHEQUE_BOUNCE_CHARGE: 'Others',
  'Bounced I/W ECS Charges': 'Others',
  BOUNCED_IW_ECS_CHARGE: 'Others',
  'Bounce Charge': 'Others',
  BOUNCE_CHARGE: 'Others',
  'Merchant Expenditure': 'Others',
  MERCHANT_EXPENDITURE: 'Others',
  'Small Savings': 'Others',
  SMALL_SAVINGS: 'Others',
  'Purchase by Card': 'Others',
  PURCHASE_BY_CARD: 'Others',
  Settlement: 'Others',
  SETTLEMENT: 'Others',
  'P2P Lending': 'Others',
  P2P_LENDING: 'Others',
  'Government Services': 'Others',
  GOVERNMENT_SERVICES: 'Others',
  'Charges/Fees': 'Others',
  CHARGES: 'Others',
  'Account Verification': 'Others',
  ACCOUNT_VERIFICATION: 'Others',
  Interior: 'Others',
  INTERIOR: 'Others',
  Finance: 'Others',
  FINANCE: 'Others',
  Pets: 'Others',
  PETS: 'Others',
  Sports: 'Others',
  SPORTS: 'Others',
  Others: 'Others',
  OTHERS: 'Others',
};

// Icon mapping for each user-facing category (using SVG icons from categories folder)
export const CATEGORY_ICONS: { [key: string]: string } = {
  // Income Categories
  Salary: salaryIcon,
  'Tax refund': taxRefundIcon,
  'Interest recovered': interestRecoveredIcon,
  'Interest credit': interestCreditIcon,
  'Cash deposits': cashDepositsIcon,
  Refunds: refundsCashbackIcon,
  'Sweep in': transferInIcon,
  'Cash back': refundsCashbackIcon,
  Subsidies: subsidiesIcon,
  'Provident Fund withdrawals': pfWithdrawalsIcon,
  'Investment income': investmentIncomeIcon,
  'Insurance claim': claimIcon,
  'Transfer in': transferInIcon,
  'Merchant income': merchantIncomeIcon,
  'Other income': otherIncomeIcon,

  // Expense Categories
  'Loan EMI': loanEmiIcon,
  'Loan disbursal': loanDisbursedIcon,
  'Tax payment': taxPaymentIcon,
  'Transfer out': transferOutIcon,
  'Cash withdrawals': cashWithdrawalsIcon,
  'Bank charges': bankChargesIcon,
  'Salary payments': salaryPaymentsIcon,
  'Credit card payments': creditCardIcon,
  'Alcohol purchase': alcoholIcon,
  'Sweep out': transferOutIcon,
  'Food & Groceries': foodGroceriesIcon,
  Transportation: transportationIcon,
  'Travel & Hospitality': transportationIcon,
  Entertainment: entertainmentIcon,
  Gaming: entertainmentIcon,
  'Gambling & Betting': gamblingBettingIcon,
  Shopping: shoppingLifestyleIcon,
  'Utilities & Recharges': utilitiesRechargesIcon,
  'BNPL payment': bnplIcon,
  'Investment expense': investmentExpenseIcon,
  'Health & wellness': healthWellnessIcon,
  'Insurance premium': insuranceIcon,
  Rent: rentIcon,
  Donation: donationIcon,
  'Shopping & lifestyle': shoppingLifestyleIcon,
  Education: educationIcon,
  'Professional services': professionalServicesIcon,
  Fines: finesIcon,
  Subscriptions: subscriptionsIcon,
  'Self transfer': selfTransfersIcon,
  'International transactions': internationalTransactionsIcon,
  'P2P transfers': p2pTransfersIcon,
  'Cheque payments': chequePaymentsIcon,
  'Cheque deposits': chequeDepositsIcon,
  'Real estate': realEstateIcon,
  Others: otherIncomeIcon,
};

// Color mapping for each user-facing category
export const CATEGORY_COLORS: { [key: string]: string } = {
  // Income Categories (Green tones)
  Salary: '#4CAF50',
  'Tax refund': '#66BB6A',
  'Interest recovered': '#4CAF50',
  'Interest credit': '#4CAF50',
  'Cash deposits': '#81C784',
  Refunds: '#4CAF50',
  'Sweep in': '#66BB6A',
  'Cash back': '#4CAF50',
  Subsidies: '#81C784',
  'Provident Fund withdrawals': '#4CAF50',
  'Investment income': '#66BB6A',
  'Insurance claim': '#4CAF50',
  'Transfer in': '#2196F3',
  'Merchant income': '#4CAF50',
  'Other income': '#66BB6A',

  // Expense Categories (Various colors)
  'Loan EMI': '#F44336',
  'Loan disbursal': '#FF5722',
  'Tax payment': '#FF9800',
  'Transfer out': '#FF9800',
  'Cash withdrawals': '#9C27B0',
  'Bank charges': '#FF9800',
  'Salary payments': '#4CAF50',
  'Credit card payments': '#2196F3',
  'Alcohol purchase': '#E91E63',
  'Sweep out': '#FF9800',
  'Food & Groceries': '#FF5722',
  Transportation: '#607D8B',
  'Travel & Hospitality': '#00BCD4',
  Entertainment: '#E91E63',
  Gaming: '#9C27B0',
  'Gambling & Betting': '#F44336',
  Shopping: '#FF9800',
  'Utilities & Recharges': '#FFC107',
  'BNPL payment': '#FF5722',
  'Investment expense': '#4CAF50',
  'Health & wellness': '#4CAF50',
  'Insurance premium': '#3F51B5',
  Rent: '#795548',
  Donation: '#E91E63',
  'Shopping & lifestyle': '#FF9800',
  Education: '#FF9800',
  'Professional services': '#607D8B',
  Fines: '#F44336',
  Subscriptions: '#FF9800',
  'Self transfer': '#2196F3',
  'International transactions': '#673AB7',
  'P2P transfers': '#2196F3',
  'Cheque payments': '#607D8B',
  'Cheque deposits': '#4CAF50',
  'Real estate': '#795548',
  Others: '#9E9E9E',
};

// Mutual Funds Sector Allocation Icons
export const SECTOR_ALLOCATION_ICONS = SectorIcons;

// Helper function to get sector icon for Mutual Funds
export const getMutualFundSectorIcon = (sectorName: string): string => {
  return getSectorIconPath(sectorName);
};

// Export helper functions for sector icons (no more lazy loading)
export {
  getSectorInitials as getMutualFundSectorInitials,
  getSectorInitialsColor as getMutualFundSectorInitialsColor,
  getSectorBackgroundColor as getMutualFundSectorBackgroundColor,
  getSectorTextColor as getMutualFundSectorTextColor,
};

// Helper functions
export const getCategoryDisplayName = (ignosisCategory: string): string => {
  return CATEGORY_MAPPING[ignosisCategory] || 'Others';
};

export const getCategoryIcon = (displayCategory: string): string => {
  return CATEGORY_ICONS[displayCategory] || otherIncomeIcon;
};

export const getCategoryColor = (displayCategory: string): string => {
  return CATEGORY_COLORS[displayCategory] || '#9E9E9E';
};

// Function to get icon and color from Ignosis category directly
export const getCategoryData = (ignosisCategory: string) => {
  const displayName = getCategoryDisplayName(ignosisCategory);
  return {
    displayName,
    icon: getCategoryIcon(displayName),
    color: getCategoryColor(displayName),
  };
};
